import React from 'react';
import { MdFileDownload } from 'react-icons/md'
import s from './FileItem.module.sass'

const FileItem = ({file: {name, id}, getFile}) => (
  <li className={s['file-item']}><span className={s['file-item__title']}>{name}</span><button onClick={ () => getFile(id) } className={`btn btn--primary ${s['download']}`}><MdFileDownload /></button></li>
)

export default FileItem;
